export default (theme, gap) => ({
  styleOverrides: {
    // Name of the slot
    root: { zIndex: theme.zIndex.drawer + 1 },
  },
});
